import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TipoReporteMadr } from '../interfaces/tipo-reporte-madr.interface';

@Injectable({
    providedIn: 'root',
})
export class ReportesMadrService {
    private apiUrl: string = environment.apiSiriUrl;

    constructor(private readonly http: HttpClient) {}

    cargarReportes(formData: FormData): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}reportes-madr`, formData);
    }

    obtenerTiposReporte(): Observable<TipoReporteMadr[]> {
        return this.http.get<TipoReporteMadr[]>(
            `${this.apiUrl}reportes-madr/tipos-reporte`
        );
    }

    descargarReporte(
        anio: number,
        reporteId: number
    ): Observable<HttpResponse<Blob>> {
        return this.http.get(
            `${this.apiUrl}reportes-madr/${anio}/${reporteId}/descargar`,
            {
                responseType: 'blob',
                observe: 'response',
            }
        );
    }
}
